export default {
  filterReports(reports, fzName, tab) {
    console.debug(`filterReports fzName=${fzName} tab=${tab}`);
    return reports.filter((r) => {
      if (r.name !== fzName) return false;
      if (tab === r.typ) return true;
      return tab === 'mangel' && r.typ === 'unfall';
    });
  },

  filterReportsByTab(reports, tab) {
    console.debug(`filterReportsByTab tab=${tab}`);
    return reports.filter((r) => {
      if (tab === r.typ) return true;
      return tab === 'mangel' && r.typ === 'unfall';
    });
  },

  sortReportsByReportingDate(reports) {
    return reports.sort((r1, r2) => {
      let r1Date = Date.parse(r1.clientdate);
      let r2Date = Date.parse(r2.clientdate);
      return r2Date - r1Date; // reverse order
    });
  },

  filterAndSortReports(reports, vehicle, tab) {
    const filteredReports = this.filterReports(reports, vehicle, tab);
    return this.sortReportsByReportingDate(filteredReports);
  },

  isCellValueSet(cell, formInput) {
    const val = formInput[cell.key];
    if (cell.cellName === 'WBUDRadioCell' && cell.radiosSorted && cell.singleSelection) {
      return cell.radiosSorted.some((radio) => formInput[radio.key] === true);
    }
    if (!val) return false;

    if (Array.isArray(val) && val.length > 0) return true;

    return true;
  },

  getMandatoryCells(cells) {
    return cells.filter((cell) => cell.mandatory && !!cell.key);
  },

  getWbKlassifierungsCell(cells) {
    return cells.find((cell) => cell.cellName === 'WBKlassifizierungCell');
  },

  findVideoCell(cells) {
    return cells.find((cell) => cell.cellName === 'WBVideoCell');
  },

  getActiveItemIndexIncrease({ wbConfig, activeItemIndex, formInput, klassifizierungen, findKlassifizierung }) {
    const activeConfig = wbConfig[activeItemIndex];
    let activeItemIndexIncrease = 0;

    activeItemIndexIncrease++;
    if (this.getWbKlassifierungsCell(activeConfig.cells)) {
      if (this.findVideoCell(wbConfig[activeItemIndex + 1].cells)) {
        //Find klassifizierung to check if video exists
        const k = findKlassifizierung(klassifizierungen, formInput.klassifizierung);
        if (!formInput.klassifizierung || !k.filename) {
          activeItemIndexIncrease++; // skip one equals this.activeItem += 2; whithout this.activeItem++ above
        }
      }
    }
    return activeItemIndexIncrease;
  },
};
